
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/genes",
      function () {
        return require("private-next-pages/genes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/genes"])
      });
    }
  